import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { CommandClickEventArgs, CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { DynamicGridBaseComponent } from 'src/app/base/shared/grid-base/dynamic-grid-base.component';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { EnumFilterService } from 'src/app/base/services/enum-filter.service';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { DiagnosticEventDTO } from 'src/app/base/models/models.swagger.generated';
import { DiagnosticEventsService } from './diagnostic-events.service';
import { diagnosticEventsDynamicDefinition } from './diagnostic-events-dynamic.definition';
import { DiagnosticEventDetailDialogComponent } from './diagnostic-event-detail-dialog/diagnostic-event-detail-dialog.component';

@Component({
  selector: 'app-diagnostic-events',
  templateUrl: './diagnostic-events.component.html',
  styleUrls: ['./diagnostic-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, GridModule, DiagnosticEventDetailDialogComponent, TranslatePipe],
  providers: [DiagnosticEventsService],
})
export class DiagnosticEventsComponent extends DynamicGridBaseComponent<typeof diagnosticEventsDynamicDefinition> implements OnInit {

  public vehicleId: number | null = 1;
  public selectedEvent: DiagnosticEventDTO | null = null;
  public showDetailDialog = false;

  constructor(
    private diagnosticEventsService: DiagnosticEventsService,
    fb: FormBuilder,
    translateService: TranslateService,
    private spinnerService: SpinnerService,
    enumFilterService: EnumFilterService,
  ) {
    super(diagnosticEventsDynamicDefinition, fb, null, translateService, diagnosticEventsService, enumFilterService);
  }

  public ngOnInit(): void {
    this.diagnosticEventsService.vehicleId = this.vehicleId;
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.diagnosticEventsService, this.spinnerService, true),
    });
    this.editSettings = {
      allowAdding: false,
      allowEditing: false,
      allowDeleting: false,
      mode: 'Dialog',
      showDeleteConfirmDialog: false,
    };
    this.gridCommands = [{
      type: 'None',
      title: this.translateService.instant('i18n.domain.analytics.diagnostic-events.view-details'),
      buttonOption: {
        cssClass: 'icon-btn',
        iconCss: 'icon-view e-icons',
      },
    } as CommandModel];
  }

  public onLoadEvents(): void {
    this.diagnosticEventsService.vehicleId = this.vehicleId;
    this.grid?.refresh();
  }

  public commandClick(args: CommandClickEventArgs): void {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      this.selectedEvent = args.rowData as DiagnosticEventDTO;
      this.showDetailDialog = true;
    }
  }

  protected getEditDialogTitleParams(): object {
    return {};
  }
}
